import axios from "axios";

// You can use your own logic to set your local or production domain
var baseDomain = "https://agroapi.irricrops.com";

if( window.location.hostname == "agrogesttion.irricrops.com" ||
    window.location.hostname == "app.agrogesttion.com"){
  baseDomain = "https://agroapi.irricrops.com";
}
// The base URL is empty this time due we are using the jsonplaceholder API
const baseURL = `${baseDomain}/api/`;

export default axios.create({
  baseURL
});
